const doc = [({"en":({"js":({"components":({"user":({"dashboard":({"date_header":({"day_name_at_date_in_monnth_in_week":"%{date} %{day}. %{month} in week %{week}"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;